import { render, staticRenderFns } from "./OfertaStatusCard.vue?vue&type=template&id=4220ff06"
import script from "./OfertaStatusCard.vue?vue&type=script&lang=js"
export * from "./OfertaStatusCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports